import {addCommas} from "@persian-tools/persian-tools";

/**
 check Image Type
 @param {string} path path file

 */

export const checkImageType = (path: string,returnType = false): boolean | "image" | "video" => {
    const typeImage = ["jpeg","png","svg","jpg"];
    if(!returnType) return typeImage.includes(path.split('.').pop());
    return (typeImage.includes(path.split('.').pop())) ? "image" : "video";
}



export const calculatePrice = (product) => {
    if(!product) return 0;
    if(product.discount == "0") return product.price;
    return Math.ceil(+product.price - (+product.price * ( +product.discount/100)));
}


export const calculateProductPrice = (product,type = "normal") => {
    if(type == "normal" || product.main_discount == "0") return addCommas(+product.main_price * product.itemcount);

    let totalPrice = product.main_price * product.itemcount;
    let totalDiscount = totalPrice * ((product.main_discount) / 100 );
    return {
        mainPrice: addCommas(totalPrice),
        currentPrice: addCommas(totalPrice - totalDiscount),
        leftOver: addCommas(totalPrice - (totalPrice - totalDiscount)),
    }
}



export const areArraysEqualByUniqueField = (arr1, arr2, uniqueField) => {
    if (arr1.length !== arr2.length) {
        return false;
    }

    const uniqueValues1 = new Set(arr1.map(item => item[uniqueField]));
    const uniqueValues2 = new Set(arr2.map(item => item[uniqueField]));

    if (uniqueValues1.size !== uniqueValues2.size) {
        return false;
    }

    for (const value of uniqueValues1) {
        if (!uniqueValues2.has(value)) {
            return false;
        }
    }

    return true;
}
